/* eslint-disable */
import _ from 'lodash';

const getters = {
  rolePermissions: (state) => state.rolePermissions,
  rolesList: (state) => Object.keys(state.rolePermissions),
  roleHasPermission: (state) => ({ role, permission }) => {
    return _.get(state, `rolePermissions.${role}.${permission}`, false);
  },
  currentUserHasPermission: (state, _getters, rootState, rootGetters) => (permission) => {
    const role = rootGetters['auth/currentUserRole'];
    return getters.roleHasPermission(state)({ role, permission });
  },
};

export default getters;
